import { RequestCreditLimitIncreaseCTA } from "./ctas";
export var RequestCreditLimitIncreaseIA = function RequestCreditLimitIncreaseIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return REQUEST_CREDIT_LIMIT_INCREASE(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [SUBMIT_REQUEST_USING_BUTTON(strictLocalize), PLEASE_NOTE(strictLocalize), TIMELINE(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(_context) {
        return RequestCreditLimitIncreaseCTA(strictLocalize).label;
      },
      linkBuilder: function linkBuilder(_context) {
        var _RequestCreditLimitIn, _RequestCreditLimitIn2;
        return (_RequestCreditLimitIn = (_RequestCreditLimitIn2 = RequestCreditLimitIncreaseCTA(strictLocalize)).getLink) === null || _RequestCreditLimitIn === void 0 ? void 0 : _RequestCreditLimitIn.call(_RequestCreditLimitIn2);
      }
    }
  };
};
var REQUEST_CREDIT_LIMIT_INCREASE = function REQUEST_CREDIT_LIMIT_INCREASE(strictLocalize) {
  return strictLocalize({
    id: "ugdDrA",
    defaultMessage: [{
      "type": 0,
      "value": "Verhoging van kredietlimiet aanvragen"
    }]
  });
};
var SUBMIT_REQUEST_USING_BUTTON = function SUBMIT_REQUEST_USING_BUTTON(strictLocalize) {
  return strictLocalize({
    id: "LkoWL2",
    defaultMessage: [{
      "type": 0,
      "value": "Als je je limiet wilt verhogen, klik je op de onderstaande knop om een aanvraag in te dienen."
    }]
  });
};
var PLEASE_NOTE = function PLEASE_NOTE(strictLocalize) {
  return strictLocalize({
    id: "lRQgRb",
    defaultMessage: [{
      "type": 0,
      "value": "Let op: als je in de afgelopen 3 maanden een verhoging hebt aangevraagd, heb je deze knop mogelijk geen toegang tot deze knop en is handmatige controle door ons betalingsteam vereist."
    }]
  });
};
var TIMELINE = function TIMELINE(strictLocalize) {
  return strictLocalize({
    id: "Jl6C3w",
    defaultMessage: [{
      "type": 0,
      "value": "We bekijken je aanvraag en je hoort meestal binnen 3 tot 7 werkdagen van ons."
    }]
  });
};